<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentOrganization /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentOrganization from '@/components/worker/dashboard/modules/users/organization/ContentOrganization.vue'

export default 
{
  name: 'Organization',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentOrganization
  }
}
</script>
<style>


</style>